(function() {
	var collapse = document.querySelectorAll('.collapse-bloc');

	function hidePlusEl(){
		collapse.forEach(function(el) {
			el.querySelector('.btn-plus').setAttribute('hidden', true);
			el.querySelector('.contenu-collapse-bloc').setAttribute('hidden', false);
		});
	}

	function collapseMobile(){
		
		collapse.forEach(function(el) {

			el.querySelector('.btn-plus').setAttribute('hidden', false);
			el.querySelector('.contenu-collapse-bloc').setAttribute('hidden', true);
			
			var btn = el.querySelector('button');
			var target = btn.nextElementSibling;

			btn.onclick = function() {
				
				var expanded = btn.getAttribute('aria-expanded') === 'true';
				btn.setAttribute('aria-expanded', !expanded);
				btn.classList.toggle('open');
				target.hidden = expanded;  
			}
		});
	}

	// Collapse content only on mobile

	var mq = window.matchMedia('(min-width: 1152px)');
	mq.addListener(WidthChange);
	WidthChange(mq);

	// media query change
	function WidthChange(mq) {
		if (mq.matches) {
		// window width is at least 1152px
			hidePlusEl();
		} else {
		// window width is less than 1152px
			collapseMobile();
		}
	}

	var commanditeContainer = document.getElementById('commandites');

	//Verifie si la commandite est chargee
	function checkCommanditeActive() {
		checkCommanditeActiveTries++;
		if (commanditeContainer == null) {
			clearInterval(intervalCommanditeActive);
			removeMarginCommandite();
		} else if (commanditeContainer.getElementsByTagName('iframe').length > 0) {
			clearInterval(intervalCommanditeActive);
		} else if (checkCommanditeActiveTries >= 10) {
			clearInterval(intervalCommanditeActive);
			removeMarginCommandite();
		}
	}

	function removeMarginCommandite(){
		var commandite = document.querySelector('.container-commanditaires');
		if (commandite) {
			commandite.style.margin = '0';
		}
    }

	var intervalCommanditeActive;
	intervalCommanditeActive = setInterval(checkCommanditeActive, 500);
	var checkCommanditeActiveTries = 0;
})()